import styled from 'styled-components';
import { ChevronRight } from 'lucide-react';
import type { SupportRequestSummary } from '@upskill/shared';
import { LANE_LABEL, STATUS_LABEL, StatusPill, UnreadDot } from './supportShared';

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  background: ${({ theme }) => theme.colors.backgrounds.white};
  border: 1px solid ${({ theme }) => theme.colors.borders.light};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => theme.spacing[3]};
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary.base};
  }
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
`;

const Subject = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  margin-top: 4px;
`;

const HandlerLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ theme }) => theme.colors.text.light};
`;

export interface RequestCardProps {
  request: SupportRequestSummary;
  onClick: () => void;
}

export function RequestCard({ request, onClick }: RequestCardProps) {
  return (
    <Card onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onClick()}>
      {request.unread ? <UnreadDot /> : <UnreadDot style={{ visibility: 'hidden' }} />}
      <Content>
        <Subject>{request.subject}</Subject>
        <MetaRow>
          <StatusPill $status={request.status}>{STATUS_LABEL[request.status]}</StatusPill>
          <HandlerLabel>{LANE_LABEL[request.lane]}</HandlerLabel>
        </MetaRow>
      </Content>
      <ChevronRight size={16} color="currentColor" />
    </Card>
  );
}

export default RequestCard;
